import classnames from 'classnames';
import ContactSupportIcon from 'components/icons/ContactSupportIcon';
import React from 'react';

import useSupportStatus from './useSupportStatus';

const CSS = require('./LiveSupportBadge.module.scss');

interface LiveSupportBadgeProps {
  openingHour?: number;
  closingHour?: number;
  supportTimeZone?: string;
}

function LiveSupportBadge({
  openingHour = 9,
  closingHour = 17,
  supportTimeZone = 'Europe/Amsterdam',
}: LiveSupportBadgeProps) {
  const { isLive, nextOpeningTime } = useSupportStatus(
    openingHour,
    closingHour,
    supportTimeZone,
  );

  return (
    <div className={CSS.Badge}>
      <div className={CSS.SupportContainer}>
        <span
          className={classnames(CSS.Dot, {
            [CSS.OnlineDot]: isLive,
            [CSS.OfflineDot]: !isLive,
          })}
        />
        <ContactSupportIcon className={CSS.SupportIcon} />
      </div>
      <div className={CSS.BadgeContent}>
        <span className={CSS.StatusTitle}>
          {isLive ? 'Live Support Available' : `Live Support Offline`}
        </span>
        <span className={CSS.StatusText}>
          {isLive ? 'Contact us now!' : `Back at ${nextOpeningTime}`}
        </span>
      </div>
    </div>
  );
}

export default LiveSupportBadge;
